import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import Notification from "../../elements/notification/Notification";
import { Helmet } from "react-helmet-async";
import LogsList from "../../logs/admin/systemLogs/LogsList";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";

import { StyledPaymentDetailsLogs } from "../styledPayment";

const PayoutLogsContainer = ({ transactionId, type, service = null }) => {
  const { t } = useTranslation("logsPage");
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState({
    main: false,
    fragment: false
  });

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "currentTab": checkFilterItem(history, "currentTab", type, false, true)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchLogs = () => {
    let itemsPerPage;

    if (logs.length === 0) {
      setLoading({ main: true, fragment: false });
      itemsPerPage = 100;
    } else {
      setLoading({ main: false, fragment: true });
      itemsPerPage = 30;
    }

    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    const otherParams = `&transactionId=${transactionId}&itemsPerPage=${itemsPerPage}` + (service ? `&collection=${service}Logs` : "");

    axios.get("/api/transaction-logs/" + filterUrl + otherParams, userAuthenticationConfig()).then(response => {
      if (response.status === 200 && response.data.list.length > 0) {
        let requestLogs = response.data.list;

        setLogs([...logs, ...requestLogs]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification)
    }).finally(() => setLoading({ main: false, fragment: false }));
  };

  const onScroll = () => {
    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;

    if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
      setFilterData({ ...filterData, page: filterData.page + 1 });
    }
  };

  useEffect(() => {
    fetchLogs();

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [filterData]);

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />

      <Helmet>
        <title>{t("meta.title")}</title>
      </Helmet>
      <StyledPaymentDetailsLogs>
        <div className="logs-head">
        </div>
        <LogsList
          loading={loading}
          logs={logs}
        />
      </StyledPaymentDetailsLogs>
    </>
  );
};

export default PayoutLogsContainer;